<div class="builder-canvas-outer-container">
  <section class="builder-canvas-container"
           id="draggable"
           #draggable>
    <div class="main-page-container">
      <db-page-constructor
        *ngIf="!singlePage; else singleSecondary"
        [pageId]="pageMeta?.at(0)?.id"
        [sectionTemplates]="sectionTemplates"
        [popupMode]="popupMode"
        [uniqueId]="uniqueIdValue"
        [user]="user"
        [website]="website"
        (openMagicLink)="openMagicLink.emit($event)">
      </db-page-constructor>
      <ng-template #singleSecondary>
        <db-secondary-pages
          [pageMeta]="(builderInteractionsService.loading|async) ? singlePageFake : [null, this.singlePageService.page.value]"
          [isSinglePage]="singlePage"
          (openMagicLink)="openMagicLink.emit($event)"
          [pagesLoading]="(builderInteractionsService.loading|async)"
          [class.invisible]="(tourStep|async) === tourSteps.PAGE_BUILDER"
          [class.disabled]="(builderHistoryService.tourStep|async) !== tourSteps.END"
          [sectionTemplates]="sectionTemplates">
        </db-secondary-pages>
      </ng-template>
    </div>
    <div class="secondary-pages-container" *ngIf="!singlePage">
      <db-secondary-pages [pageMeta]="(builderInteractionsService.loading|async)?fakePages:pageMeta"
                          (openMagicLink)="openMagicLink.emit($event)"
                          [pagesLoading]="(builderInteractionsService.loading|async)"
                          [class.invisible]="(tourStep|async) === tourSteps.PAGE_BUILDER"
                          [class.disabled]="(builderHistoryService.tourStep|async) !== tourSteps.END"
                          [sectionTemplates]="sectionTemplates">
      </db-secondary-pages>
      <div class="cover"
           *ngIf="(tourStep|async) === tourSteps.PAGE_BUILDER">
      </div>
    </div>
  </section>
  <div class="right-side-actions" [class.with-animation]="_commonDataService.prefilledAi">
    <db-canvas-page-actions [sectionTemplates]="sectionTemplates">
    </db-canvas-page-actions>
  </div>
</div>


